module.exports = __webpack_public_path__ + "static/joanna-kosinska-szFUQoyvrxM-unsplash 2-d9faf207f01b4de5692e2fbebeee6f1d.png";